<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="#000" stroke="#000" d="M4.5 2.25h15v19.5h-15z"/>
  <path stroke="#000" d="M1.5 22h21"/>
</svg>
